import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { useAddRoleMutation, useDeleteRoleMutation, useEditRoleMutation } from "../../../redux/api/rolesApi/roles";
import { EntRole } from "../../../models/role";
import { getCookie } from "typescript-cookie";


const useRoles = (modal: any, refresh?: () => void) => {
    const { t } = useTranslation()
    const { confirm } = modal;
    const [addRole] = useAddRoleMutation();
    const [deleteRole] = useDeleteRoleMutation();
    const [editRole] = useEditRoleMutation();


    async function onAddRole(newRole: EntRole): Promise<boolean> {
        try {
            let status: boolean = false;
            await addRole(newRole).then((response: any) => {
                if (response.error) {
                    const isKyrgyz = getCookie('i18next') === 'ky';
                    const lang = isKyrgyz ? 'kg' : 'ru';
                    const res = response.error.data?.res;
                    const errorMessages = Array.isArray(res)
                        ? res.map((error: any) => error[lang] || error.ru).join('\n')
                        : response.error.data?.msg || t('unknownError'); 
                    throw new Error(errorMessages);
                }
                if (response.data.success) {
                    status = true;
                    message.success(t('msg.successAdd'));
                    if(refresh) refresh();
                }
            }).catch((error:any) => {
                modal.error({ title: t('msg.error'), content: String(error.message) });
          
            });
            return status;
        } catch (error: any) {
            modal.error({ title: t('msg.error'), content: String(error.message) });
            return false;
        }
    }
    async function onDeleteRole(role: EntRole) {
        try {
            let status: boolean = false;
            confirm({
                centered: true,
                title: t('msg.confirmDeleteText'),
                okText: t('general.yes'),
                cancelText: t('general.no'),
                onOk() {
                    deleteRole(role.id).then((response: any) => {
                        if (response.error) {
                            const isKyrgyz = getCookie('i18next') === 'ky';
                            const lang = isKyrgyz ? 'kg' : 'ru';
                            const res = response.error.data?.res;
                            const errorMessages = Array.isArray(res)
                                ? res.map((error: any) => error[lang] || error.ru).join('\n')
                                : response.error.data?.msg || t('unknownError'); 
                            throw new Error(errorMessages);
                        }
                        if (response.data.success) {
                            status = true;
                            Modal.success({title: t('msg.successDelete')});
                            if(refresh) refresh();
                        }
                    }).catch((error) => {
                        Modal.error({ title: t('msg.error'), content: String(error.message) });
                        
                    });
                }
            })
            return status
        } catch (error: any) {
            Modal.error({ title: t('msg.error'), content: String(error.message) });
            return false;
        }
    };
    async function onEditRole(editedRole: EntRole): Promise<boolean> {
        try {
            let status: boolean = false;
            await editRole(editedRole).then((response: any) => {
                   if (response.error) {
                                               const isKyrgyz = getCookie('i18next') === 'ky';
                                               const lang = isKyrgyz ? 'kg' : 'ru';
                                               const res = response.error.data?.res;
                                               const errorMessages = Array.isArray(res)
                                                   ? res.map((error: any) => error[lang] || error.ru).join('\n')
                                                   : response.error.data?.msg || t('unknownError'); 
                                               throw new Error(errorMessages);
                                           }
                if (response.data.success) {
                    status = true;
                    Modal.success({title: t('msg.successEdited')});
                    if(refresh) refresh();
                }
            }).catch((error: any) => {
                Modal.error({ title: t('msg.error'), content: String(error.message) });
            });
            return status;
        } catch (error: any) {
            Modal.error({ title: t('msg.error'), content: String(error.message) });
            return false;
        }
    };
    return { onAddRole,onDeleteRole, onEditRole }

}
export { useRoles };

